import {cast, flow, Instance, types} from 'mobx-state-tree';
import {EComponentBaseType, ILumpComponent} from '@progress-fe/core';
import {CatalogsApi, LumpComponent} from 'api';
import {RequestModel, ResetModel} from 'core/models';

const LumpComponentsCatalog = types.compose(
  ResetModel,
  types
    .model('LumpComponentsCatalog', {
      components: types.optional(types.array(types.frozen<ILumpComponent>()), []),
      fetchRequest: types.optional(RequestModel, {})
    })
    .actions((self) => ({
      load: flow(function* () {
        const response: Array<LumpComponent> = yield self.fetchRequest.send(
          CatalogsApi.catalogsGetLumpComponentsCatalog.bind(CatalogsApi),
          {}
        );

        const components: ILumpComponent[] = response.map((c) => ({
          uuid: c.uuid,
          name: c.name,
          formula: c.formula,
          structure: c.uNIFACStructure,
          baseType: EComponentBaseType.LUMP,
          model: c.model
        }));

        self.components = cast(components);
      })
    }))
);

export type TLumpComponentsCatalogModel = Instance<typeof LumpComponentsCatalog>;

export {LumpComponentsCatalog};
